export default "__VITE_ASSET__BcN8lh3Q__"